import {
  Component,
  input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { InputText } from '@openng/optimus-ui/inputtext';
import { ButtonDirective } from '@openng/optimus-ui/button';

@Component({
  selector: 'app-contact-mobile-filter',
  templateUrl: './contact-mobile-filter.component.html',
  styleUrls: ['./contact-mobile-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslateDirective,
    FormsModule,
    InputText,
    ButtonDirective,
    TranslatePipe,
  ],
})
export class ContactMobileFilterComponent {
  readonly showMobileFilter = input<boolean>();
  readonly mobileFilterEvent = output<any>();

  name!: string | null;
  supervisor!: string | null;

  mobileFilter() {
    this.mobileFilterEvent.emit({
      name: this.name,
      supervisor: this.supervisor,
    });
  }

  clear() {
    this.name = null;
    this.supervisor = null;
    this.mobileFilter();
  }
}
